import { render } from "./DevSecOps.vue?vue&type=template&id=3ab9bbee&scoped=true&ts=true"
import script from "./DevSecOps.vue?vue&type=script&lang=ts"
export * from "./DevSecOps.vue?vue&type=script&lang=ts"

import "./DevSecOps.vue?vue&type=style&index=0&id=3ab9bbee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab9bbee"]])

export default __exports__